<template>
	<div
		class="athlete-selector"
	>
		<!-- DROPDOWN -->
		<Dropdown
			:value="value"
			:placeholder="placeholder || $I18n.trans('one.search_athlete')"
			class="form-dropdown"
			:options="options"
			searchable
			@input="onSelect"
		>
			<template #selected-item="{ selectedOption }">
				<SelectedItem
					:placeholder="placeholder"
					:item="selectedOption"
				/>
			</template>
			<template #item-list="{ option, selectedOption }">
				<ListItem
					:item="option"
					:is-selected="selectedOption === option"
				/>
			</template>
		</Dropdown>
	</div>
</template>

<script>
import Dropdown from '@components/dropdown/Dropdown.vue';
import SelectedItem from '@js/one/components/AthleteSelector/SelectedItem.vue';
import ListItem from '@js/one/components/AthleteSelector/ListItem.vue';
import { ATHLETE_ALL_KEY, ATHLETE_UNKNOWN_ENTITY } from '@videotools/js/constants/athletes';

export default {
	name:       'AthleteSelector',
	components: { Dropdown, SelectedItem, ListItem },
	props:      {
		athletes: {
			type:    Array,
			default: () => [],
		},
		value: {
			type:    [Object, String],
			default: null,
		},
		placeholder: {
			type: String,
		},
		hasAllOption: {
			type: Boolean,
		},
	},
	data() {
		return {
			isOpen:          false,
			selectedAthlete: null,
		};
	},
	computed: {
		options() {
			return [
				...(this.hasAllOption
					? [{
						label: this.allAthletesOptionLabel,
						value: ATHLETE_ALL_KEY,
					}]
					: []
				),
				{
					label: ATHLETE_UNKNOWN_ENTITY.name,
					value: ATHLETE_UNKNOWN_ENTITY,
					icon:  'users-wm',
				},
				...this.athletes.map((athlete) => ({
					id:    athlete.id,
					value: athlete,
					label: athlete.name,
					image: athlete.imageUrl,
				})),
			];
		},
		allAthletesOptionLabel() {
			return this.transUcfirst('one.all_athletes') + ` (${this.athletes.length})`;
		},
	},
	methods: {
		onSelect(value) {
			this.$emit('input', value);
			this.isOpen = false;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.athlete-selector {
	display: flex;
	flex-direction: column;

	::v-deep {
		.form-input {
			background: var(--color-grey-900);
		}
	}
}
</style>
